import {createReducer} from '@reduxjs/toolkit';
import {getAllAttributesByNameSuccess} from 'src/openapi/apis/AttributeControllerApi';
import {AttributeDetailInfo} from 'src/openapi/models/AttributeDetailInfo';

type State = {
    data: {
        [attributeName: string]: Array<AttributeDetailInfo>,
    },
};

const defaultState = {
    data: {},
};

export const attributeInfo = createReducer<State>(defaultState, builder => builder
    .addCase(getAllAttributesByNameSuccess, (state, action) => {
        const attributeName = action.payload.meta.name;

        const values = action.payload.data;

        state.data = {
            ...state.data,
            [attributeName]: values,
        };
    }),
);
